import React, { useContext } from 'react'
import { RegistrationFormContext } from './types'
import { InputRadio } from '../../../../HtmlComponents/InputRadio'
import { InputElement } from '../../../../HtmlComponents/InputElement'

const Section5 = () => {
  const { 
    workInPublicSector, setWorkInPublicSector,

   } = useContext(RegistrationFormContext)

  const publicSectorArr: string[] = ["Hopital", "Dispensaires, centre de soins", "Medecine scolaire", "Medecine de travail", "Etablissement militaire", "Expertise", "Administration", "Organisme international"]

  return (
    <>    
    <div>
      <p className='font-bold text-main'>{"27) "}exercez-vous en tantque medecin etranger: </p>
      <InputRadio 
        checked={workInPublicSector === "Hopital" && true} 
        labelName="Hopital"
        id="Hopital" 
        value={"Hopital"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={workInPublicSector === "Dispensaires, centre de soins" && true} 
        labelName="Dispensaires, centre de soins"
        id="DispensairesCentreDeSoins" 
        value={"Dispensaires, centre de soins"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={workInPublicSector === "Medecine scolaire" && true} 
        labelName="Medecine scolaire"
        id="MedecineScolaire" 
        value={"Medecine scolaire"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={workInPublicSector === "Medecine de travail" && true} 
        labelName="Medecine de travail"
        id="MedecineDeTravail" 
        value={"Medecine de travail"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={workInPublicSector === "Etablissement militaire" && true} 
        labelName="Etablissement militaire"
        id="EtablissementMilitaire" 
        value={"Etablissement militaire"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={workInPublicSector === "Expertise" && true} 
        labelName="Expertise"
        id="Expertise" 
        value={"Expertise"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={workInPublicSector === "Administration" && true} 
        labelName="Administration"
        id="Administration" 
        value={"Administration"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={workInPublicSector === "Organisme international" && true} 
        labelName="Organisme international"
        id="OrganismeInternational" 
        value={"Organisme international"} 
        setValue={setWorkInPublicSector}
      />
      <InputRadio 
        checked={(workInPublicSector && !publicSectorArr.includes(workInPublicSector)) ? true : false} 
        labelName="Autre"
        id="Autre" 
        value={"Autre"} 
        setValue={setWorkInPublicSector}
      />
      {(workInPublicSector && !publicSectorArr.includes(workInPublicSector)) && <InputElement inputClass='md:w-1/2' name='Lesquels?' value={workInPublicSector} setValue={setWorkInPublicSector}/>}    
    </div>
  </>
  )
}

export default Section5